// app-promotion-sheet.component.ts
import { Component, inject, Input } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-promotion-sheet',
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: 'app-promotion.component.html',
  styleUrl: 'app-promotion.component.scss',
})
export class AppPromotionComponent {
  data = inject(MAT_BOTTOM_SHEET_DATA);
   @Input() lang:string;
  private bottomSheetRef = inject(MatBottomSheetRef<AppPromotionComponent>);
  
  close(): void {
    this.bottomSheetRef.dismiss();
  }
}